import { Slot, useSegments } from "expo-router";
import { useCallback } from "react";
import { View } from "ui/atoms/view";
import GoBack from "ui/molecules/common/GoBack";
import { MenuSection } from "app/features/reporting/organisms/MenuSection";

export default function BodyMapLayout() {
  const segments = useSegments() as string[];
  const reportsPath = `/${segments.slice(0, 5).join("/")}`;

  const isSelected = useCallback(
    (endSegment: string) => {
      return segments.includes(endSegment);
    },
    [segments],
  );

  const entriesMenuOptions = [
    {
      label: "Current",
      href: `./current`,
      selected: isSelected("current"),
    },
    {
      label: "Resolved",
      href: `./resolved`,
      selected: isSelected("resolved"),
    },
  ];

  return (
    <View className="resident-container">
      <View className="self-start mb-16">
        <GoBack path={reportsPath} />
      </View>
      <View className="flex-row">
        <View className="w-[220px] lg:w-[237px]">
          <MenuSection options={entriesMenuOptions} />
        </View>
        <View className="flex-1 ml-10">
          <Slot />
        </View>
      </View>
    </View>
  );
}
